module.exports = __webpack_public_path__ + "static/media/email.0a20c0be.svg";